import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { NzModalService } from 'ng-zorro-antd/modal';
import { AcessoService } from './acesso.service';
import { ModuloAcesso } from './acesso.model';

const ORIENTACAO_PLANILHAS = "Você não possui acesso à este módulo. As autorizações/renovações devem ser efetuadas pelos gerentes diretamente no SPO (http://10.7.16.93/spo), através do botão 'Autorização'.";

/** Integrar somente a rotas reais da área indicada. Não autoriza operações no servidor. */
export function acessoGuard(modulo: ModuloAcesso): CanActivateFn {
  return () => {
    const acesso = inject(AcessoService);
    const router = inject(Router);
    const contexto = acesso.obterContexto();
    if (!contexto) {
      acesso.limparContexto();
      return router.createUrlTree(['/acesso']);
    }
    if (contexto.capacidadeEntrada[modulo] === true) return true;
    inject(NzModalService).error({
      nzTitle: 'Aviso',
      nzContent: modulo === 'planilhas' ? ORIENTACAO_PLANILHAS : 'Acesso Negado.',
      nzOkText: 'OK'
    });
    return false;
  };
}
